export enum ENDPOINTS {
  // ------------------------------------------------------ GENERAL ENDPOINTS ------------------------------------------------------ //
  // ASSETS
  ASSETS_IMAGES_UPLOAD,
  ASSETS_IMAGES_DELETE,

  // AUTH
  AUTH_REFRESH_TOKEN,
  AUTH_LOGIN,
  AUTH_PROFILE_IMAGE_UPLOAD,
  AUTH_CODE,
  AUTH_LOGIN_IMPERSONATE,
  AUTH_CHECK_USER,
  AUTH_USERNAME,
  AUTH_LOGOUT,
  AUTH_FORGOT_PASSWORD,
  AUTH_VALIDATE_TOKEN,
  AUTH_RESET_PASSWORD,
  AUTH_REGISTER,
  AUTH_VERIFY,
  AUTH_PROFILE,
  AUTH_SEND_OTP,

  // CONNECTED-APPS
  CONNECTED_APPS_CONNECT_NEW_APPS,
  CONNECTED_APPS_GET_ALL_APPS,
  CONNECTED_APPS_GET_ONE_APP,
  CONNECTED_APPS_UPDATE_ONE_APP,
  CONNECTED_APPS_DELETE_ONE_APP,
  CONNECTED_APPS_CONNECT_OR_DISCONNECT_APP,
  CONNECTED_APPS_GET_ALL_FIELDS_OF_A_CONNECTED_APP,
  CONNECTED_APPS_GET_ALL_PERMISSIONS_OF_A_CONNECTED_APP,
  CONNECTED_APPS_GET_ALL_ROLES_OF_A_CONNECTED_APP,
  CONNECTED_APPS_GET_ALL_DOCUMENTATIONS_OF_A_CONNECTED_APP,
  CONNECTED_APPS_GET_ALL_REFERENCES_OF_A_CONNECTED_APP,
  CONNECTED_APPS_GENERATE_PUBLIC_API_KEY,
  CONNECTED_APPS_GENERATE_PUBLIC_CLIENT_CREDENTIALS,
  CONNECTED_APPS_GENERATE_SECRETS,
  CONNECTED_APPS_SAVE_GENERATED_PUBLIC_KEY,
  CONNECTED_APPS_SAVE_DELETED_PUBLIC_KEY,
  CONNECTED_APPS_SAVE_DELETED_CLIENT_SECRET,
  CONNECTED_APPS_UPDATE_GENERATED_PUBLIC_KEY,
  CONNECTED_APPS_GET_SPECIFIC_GENERATED_KEY,
  CONNECTED_APPS_GET_ALL_GENERATED_KEYS,
  CONNECTED_APPS_DELETE_KEY,
  CONNECTED_APPS_RESTORE_KEY,
  CONNECTED_APPS_HANDSHAKE,

  // CONNECTIONS
  CONNECTIONS_GET_ALL,
  CONNECTIONS_UPDATE,

  // IDENTITIES
  IDENTITIES_EL_ASYNC_GET,
  IDENTITIES_HIERARCHICAL_EL_ASYNC,
  IDENTITIES_ROLES_EL_ASYNC,
  IDENTITIES_GET_ONE,
  IDENTITIES_GET_INTERNAL_FIELD,
  IDENTITIES_SUBORDINATES,
  IDENTITIES_SUBORDINATE_IDS,
  IDENTITIES_HIERARCHICAL,

  //INTEGRATION - ENDPOINTS
  INTEGRATION_ENDPOINTS_GET_ALL,
  INTEGRATION_ENDPOINTS_ADD_ONE,
  INTEGRATION_ENDPOINTS_UPDATE_ONE,
  INTEGRATION_ENDPOINTS_DELETE_ONE,
  INTEGRATION_ENDPOINTS_RESTORE_ONE,
  INTEGRATION_ENDPOINTS_VERIFY_ONE,

  //INTEGRATION - MAPPING
  INTEGRATION_MAPPINGS_ADD_ONE,
  INTEGRATION_MAPPINGS_GET_ALL,
  INTEGRATION_MAPPINGS_UPDATE_ONE,
  INTEGRATION_MAPPINGS_DELETE_ONE,
  INTEGRATION_MAPPINGS_RESTORE_ONE,
  INTEGRATION_MAPPINGS_VERIFY_ONE,

  // FILES
  FILES_UPLOAD,
  FILES_DOWNLOAD,
  FILES_DELETE,

  // JOB_QUEUE
  JOB_QUEUE_CHECK_STATUS,

  // MODULES
  MODULES_GET_ALL,
  MODULES_GET_ONE_BY_ID,
  MODULES_UPDATE,
  MODULES_RESET,

  // PERSONALIZATION
  PERSONALIZATION_GET,
  PERSONALIZATION_UPDATE,

  // NOTIFICATION
  NOTIFICATION_CERATE_WITH_USER,
  NOTIFICATION_CERATE_WITHOUT_USER,
  NOTIFICATION_CREATE_MULTIPLE_NOTIFICATIONS_WITH_USERS,
  NOTIFICATION_GET,
  NOTIFICATION_GET_USER_NOTIFICATIONS,
  NOTIFICATION_FILTER,
  NOTIFICATIONS_MARK_AS_READ,
  NOTIFICATIONS_MARK_ALL_AS_READ,

  // CONFIGURABLE_FIELDS - VALIDATIONS
  CONFIGURABLE_FIELDS_VALIDATIONS_NAME,
  CONFIGURABLE_FIELDS_VALIDATIONS_PHONE_NUMBER,
  CONFIGURABLE_FIELDS_VALIDATIONS_ADDRESS,
  CONFIGURABLE_FIELDS_VALIDATIONS_EMAIL,

  // REFERENCES - PREDEFINED_REFERENCES
  PREDEFINED_REFERENCES_GET_VALUE,

  // REFERENCES - REFERENCE_CATEGORIES
  REFERENCE_CATEGORIES_GET_ALL,
  REFERENCE_CATEGORIES_GET_SINGLE,
  REFERENCE_CATEGORIES_GET_EXTERNAL,
  REFERENCE_CATEGORIES_GET_EXTERNAL_DELETE,
  REFERENCE_CATEGORIES_ADD_NEW,
  REFERENCE_CATEGORIES_UPDATE,
  REFERENCE_CATEGORIES_DELETE,
  REFERENCE_CATEGORIES_RESTORE,
  REFERENCE_CATEGORIES_REFERENCES_GET_ALL,
  REFERENCE_CATEGORIES_REFERENCES_GET_ALL_V2,
  REFERENCE_CATEGORIES_REFERENCES_ADD_NEW,
  REFERENCE_CATEGORIES_REFERENCES_BULK_ADD,

  // REFERENCES - PUBLIC
  REFERENCE_CATEGORIES_PUBLIC_GET_SINGLE,
  REFERENCE_VACANCIES_PUBLIC_GET_SINGLE,
  REFERENCE_GENERAL_PUBLIC_GET_SINGLE,
  REFERENCE_SUBMISSIONS_PUBLIC_GET_SINGLE,
  REFERENCE_CATEGORIES_PUBLIC_GET_BLOG_REFERENCES,
  REFERENCE_CATEGORIES_PUBLIC_GET_SUBMISSION_REFERENCES,
  REFERENCE_CATEGORIES_PUBLIC_GET_VACANCY_CATEGORY,
  REFERENCE_CATEGORIES_PUBLIC_GET_VACANCY_LOCATION,
  REFERENCE_CATEGORIES_PUBLIC_GET_VACANCY_MODALITY,
  REFERENCE_CATEGORIES_PUBLIC_GET_VACANCY_TYPES,
  REFERENCE_CATEGORIES_PUBLIC_GET_ACTIVITY_REFERENCES,
  REFERENCE_CATEGORIES_PUBLIC_GET_UNIVERSITY_REFERENCES,
  REFERENCE_CATEGORIES_PUBLIC_GET_ALL_VACANCY_CATEGORIES,
  REFERENCE_CATEGORIES_PUBLIC_GET_GET_TO_KNOW_QUESTIONS_ANSWERS,
  REFERENCE_BLOG__CATEGORIES_PUBLIC_GET_SINGLE,
  REFERENCE_CASE_STUDIES__CATEGORIES_PUBLIC_GET_SINGLE,
  REFERENCE_NEWS__CATEGORIES_PUBLIC_GET_SINGLE,

  // REFERENCES - REFERENCES
  REFERENCE_EDIT,
  REFERENCE_DELETE,
  REFERENCE_RESTORE,
  REFERENCES_FIELDS_GET_VALUE,

  // REFERENCES - TEMPLATES
  TEMPLATES_ADD_NEW,
  TEMPLATES_UPDATE_ONE,
  TEMPLATES_GET_ONE,

  // REFERENCES - FORMULA
  FORMULA_ANALYZE,
  FORMULA_EVALUATE,

  // STORAGE - INTERNAL
  STORAGE_INTERNAL_CONTENT,
  STORAGE_INTERNAL_DELETE,
  STORAGE_INTERNAL_PREVIEW,
  STORAGE_INTERNAL_UPLOAD,
  STORAGE_INTERNAL_DOWNLOAD,
  STORAGE_INTERNAL_SHARE_INTERNALLY,

  // SETUP - IAM
  SETUP_IAM_AUTHORIZERS_AZURE,
  SETUP_IAM_HANDSHAKE,

  // SETUP - BACKUP_SCHEDULES
  SETUP_BACKUPS_SCHEDULES_ADD_NEW,
  SETUP_BACKUPS_SCHEDULES_GET_ALL,
  SETUP_BACKUPS_SCHEDULES_DELETE_ONE,
  SETUP_BACKUPS_SCHEDULES_ENABLE_DISABLE_ONE,

  // SETUP - BACKUPS
  SETUP_BACKUPS_BACKUP_NOW,
  SETUP_BACKUPS_GET_ALL,
  SETUP_BACKUPS_DOWNLOAD_ONE,
  SETUP_BACKUPS_DELETE_ONE,

  // SETUP - LANGUAGES
  SETUP_LANGUAGES_ADD_ONE,
  SETUP_LANGUAGES_GET_ALL,
  SETUP_LANGUAGES_GET_ONE,
  SETUP_LANGUAGES_UPDATE_ONE,
  SETUP_LANGUAGES_ENABLE_DISABLE_ONE,
  SETUP_LANGUAGES_DELETE_ONE,
  SETUP_LANGUAGES_REFRESH_ONE,
  SETUP_LANGUAGES_GET_CONTENT_OF_ONE,

  // SETUP - REFERENCE MAPPING
  SETUP_GET_ALL_REFERENCE_MAPPINGS,
  SETUP_GET_REFERENCE_MAPPING_BY_KEY,
  SETUP_UPDATE_REFERENCE_MAPPING,

  // SETUP - CURRENCIES
  SETUP_CURRENCIES_ADD_ONE,
  SETUP_CURRENCIES_GET_ALL,
  SETUP_CURRENCIES_GET_ONE,
  SETUP_CURRENCIES_UPDATE_ONE,
  SETUP_CURRENCIES_DELETE_ONE,
  SETUP_CURRENCIES_RESTORE_ONE,
  SETUP_CURRENCIES_TOGGLE_BASE_CURRENCY,

  // SETUP - EXTERNAL SYSTEMS
  SETUP_EXTERNAL_SYSTEMS_GET_ALL,
  SETUP_EXTERNAL_SYSTEM_GET_EXTERNAL_REFERENCE_CATEGORIES,
  SETUP_EXTERNAL_SYSTEMS_UPDATE_ONE,

  // SETUP - EXTERNAL SYSTEMS - KEYS

  SETUP_EXTERNAL_SYSTEMS_KEYS_GET_ALL,
  SETUP_EXTERNAL_SYSTEMS_KEYS_GET_ONE,
  SETUP_EXTERNAL_SYSTEMS_KEYS_DELETE_ONE,
  SETUP_EXTERNAL_SYSTEMS_KEYS_RESTORE_ONE,
  SETUP_EXTERNAL_SYSTEMS_KEYS_SAVE_KEY,
  SETUP_EXTERNAL_SYSTEMS_KEYS_GENERATE_NEW_KEY,

  // ------------------------------------------------------ GENERAL ENDPOINTS ------------------------------------------------------ //

  // ARTICLE BLOG
  ARTICLE_BLOG_CREATE_NEW,
  ARTICLE_BLOG_GET_ALL,
  ARTICLE_BLOG_CREATE_DRAFT,
  ARTICLE_BLOG_PERMALINK,
  ARTICLE_BLOG_DELETE,
  ARTICLE_BLOG_DELETE_PERMANENT,
  ARTICLE_BLOG_RESTORE,
  ARTICLE_BLOG_GET_ONE,
  ARTICLE_BLOG_UPDATE_ONE,
  ARTICLE_BLOG_PUBLISH,
  ARTICLE_BLOG_CREATE_PUBLISH,
  ARTICLE_BLOG_ARCHIVE,

  // ARTICLE BLOG PUBLIC
  PUBLIC_ARTICLE_BLOG_GET_ALL,
  PUBLIC_ARTICLE_BLOG_GET_ALL_FEATURED,
  PUBLIC_ARTICLE_BLOG_GET_ALL_NON_FEATURED,
  PUBLIC_ARTICLE_BLOG_GET_ALL_CATEGORIES,
  PUBLIC_ARTICLE_BLOG_GET_BY_SLUG,
  PUBLIC_ARTICLE_BLOG_UPDATE_BY_SLUG,

  // ARTICLE CASE STUDIES
  ARTICLE_CASE_STUDIES_CREATE_NEW,
  ARTICLE_CASE_STUDIES_GET_ALL,
  ARTICLE_CASE_STUDIES_CREATE_DRAFT,
  ARTICLE_CASE_STUDIES_PERMALINK,
  ARTICLE_CASE_STUDIES_DELETE,
  ARTICLE_CASE_STUDIES_DELETE_PERMANENT,
  ARTICLE_CASE_STUDIES_RESTORE,
  ARTICLE_CASE_STUDIES_GET_ONE,
  ARTICLE_CASE_STUDIES_UPDATE_ONE,
  ARTICLE_CASE_STUDIES_PUBLISH,
  ARTICLE_CASE_STUDIES_CREATE_PUBLISH,
  ARTICLE_CASE_STUDIES_ARCHIVE,

  // ARTICLE CASE STUDIES PUBLIC
  PUBLIC_ARTICLE_CASE_STUDIES_GET_ALL,
  PUBLIC_ARTICLE_CASE_STUDIES_GET_BY_SLUG,
  PUBLIC_ARTICLE_CASE_STUDIES_UPDATE_BY_SLUG,

  //ARTICLE NEWS
  ARTICLE_NEWS_CREATE_NEW,
  ARTICLE_NEWS_GET_ALL,
  ARTICLE_NEWS_CREATE_DRAFT,
  ARTICLE_NEWS_PERMALINK,
  ARTICLE_NEWS_DELETE,
  ARTICLE_NEWS_DELETE_PERMANENT,
  ARTICLE_NEWS_RESTORE,
  ARTICLE_NEWS_GET_ONE,
  ARTICLE_NEWS_UPDATE_ONE,
  ARTICLE_NEWS_PUBLISH,
  ARTICLE_NEWS_ARCHIVE,
  ARTICLE_NEWS_CREATE_PUBLISH,

  // ARTICLE NEWS PUBLIC
  PUBLIC_ARTICLE_NEWS_GET_ALL,
  PUBLIC_ARTICLE_NEWS_GET_BY_SLUG,
  PUBLIC_ARTICLE_NEWS_UPDATE_BY_SLUG,

  // ARTICLE EVENTS
  ARTICLE_EVENTS_CREATE_NEW,
  ARTICLE_EVENTS_GET_ALL,
  ARTICLE_EVENTS_CREATE_DRAFT,
  ARTICLE_EVENTS_DELETE,
  ARTICLE_EVENTS_DELETE_PERMANENT,
  ARTICLE_EVENTS_RESTORE,
  ARTICLE_EVENTS_GET_ONE,
  ARTICLE_EVENTS_UPDATE_ONE,
  ARTICLE_EVENTS_PUBLISH,
  ARTICLE_EVENTS_ARCHIVE,
  ARTICLE_EVENTS_CREATE_PUBLISH,

  // ARTICLE EVENTS PUBLIC
  PUBLIC_ARTICLE_EVENTS_GET_ALL,

  // BOOKINGS
  BOOKINGS_CREATE_NEW,
  BOOKINGS_GET_ALL,
  BOOKINGS_GET_ONE,
  BOOKINGS_UPDATE_ONE,
  BOOKINGS_DELETE_ONE,

  // CONSULTATIONS
  CONSULTATIONS_GET_ALL,
  CONSULTATIONS_CREATE_NEW,
  CONSULTATIONS_DELETE,
  CONSULTATIONS_RESTORE_ONE,
  CONSULTATIONS_SEND,

  // CONSULTATION CONFIGURATION
  CONSULTATION_CONFIGURATIONS_CREATE_NEW,
  CONSULTATION_CONFIGURATIONS_GET_ALL,

  // PROPOSALS
  PROPOSALS_GET_ALL,
  PROPOSALS_CREATE_NEW,
  PROPOSALS_DELETE,
  PROPOSALS_RESTORE,
  PROPOSALS_SEND,

  // PROPOSAL CONFIGURATION
  PROPOSAL_CONFIGURATIONS_CREATE_NEW,
  PROPOSAL_CONFIGURATIONS_GET_ALL,

  // PROJECT_MANAGEMENT
  PROJECT_GET_ALL,
  PROJECT_UPDATE_ONE,
  PROJECT_GET_ONE,
  PROJECT_DELETE_ONE,
  PROJECT_RESTORE_ONE,
  PROJECT_GET_OVERVIEW,
  // SUBSCRIBERS
  SUBSCRIBERS_GET_ALL,
  SUBSCRIBERS_CREATE_NEW,
  SUBSCRIBERS_DELETE,
  SUBSCRIBERS_RESTORE,

  // VACANCIES
  VACANCIES_CREATE_NEW,
  VACANCIES_GET_ALL,
  VACANCIES_GET_REFERENCES,
  VACANCIES_GET_ONE,
  VACANCY_UPDATE_ONE,
  VACANCY_DELETE_ONE,
  VACANCY_RESTORE_ONE,
  PAUSE_RESTORE_ONE,
  CONTINUE_RESTORE_ONE,
  VACANCIES_GET_SUBMISSION_COUNT,

  // VACANCIES - PUBLIC
  VACANCIES_PUBLIC_GET_ALL_ACTIVE,
  VACANCIES_PUBLIC_VIEW_COUNT,

  // SUBMISSIONS
  SUBMISSIONS_GET_ALL,
  SUBMISSIONS_CREATE_NEW,
  SUBMISSIONS_RESTORE_ONE,
  SUBMISSIONS_UPDATE,
  SUBMISSIONS_DELETE,
  SUBMISSIONS_SEND_MESSAGE,
  SUBMISSIONS_SENT_MESSAGES,
  SUBMISSIONS_STATUS_CHANGE,
  SUBMISSIONS_SEND_MAIL,

  // SUBMISSIONS - PUBLIC
  SUBMISSION_PUBLIC_CREATE_SUBMISSION,
  SUBMISSIONS_PUBLIC_GET_RESPONSE,
  SUBMISSIONS_PUBLIC_GET_RESPONSE_HR,

  // ROOMS
  ROOMS_CREATE_NEW,
  ROOMS_GET_ALL,
  ROOMS_GET_ONE,
  ROOMS_UPDATE_ONE,
  ROOMS_DELETE_ONE,
  ROOMS_RESTORE_ONE,

  // INVENTORY
  INVENTORY_CREATE_NEW,
  INVENTORY_GET_ALL,
  INVENTORY_GET_ONE,
  INVENTORY_UPDATE_ONE,
  INVENTORY_DELETE_ONE,
  INVENTORY_RESTORE_ONE,

  // EMPLOYEE
  EMPLOYEE_CREATE_NEW,
  EMPLOYEE_GET_ALL,
  EMPLOYEE_GET_ONE,
  EMPLOYEE_GET_ONE_BY_EMPLOYEEID,
  EMPLOYEE_GET_ONE_OVERVIEW,
  EMPLOYEE_GET_ONE_CAREER,
  VALIDATE_EMPLOYEE,
  EMPLOYEE_GET_ROLE_LIST,
  EMPLOYEE_UPDATE_ONE,
  EMPLOYEE_CAREER_UPDATE_ONE,
  EMPLOYEE_ENABLE,
  EMPLOYEE_DISABLE,
  DELETE_PROMOTION,

  // HOLIDAY
  HOLIDAY_CREATE_NEW,
  HOLIDAY_GET_ALL,
  HOLIDAY_GET_ONE,
  HOLIDAY_UPDATE_ONE,
  HOLIDAY_DELETE_ONE,
  HOLIDAY_RESTORE_ONE,
  HOLIDAY_BULK_UPLOAD,

  // WORKSTATIONS
  WORKSTATIONS_CREATE_NEW,
  WORKSTATIONS_GET_ALL,
  WORKSTATIONS_DELETE,
  WORKSTATIONS_HISTORY,

  // WORKSTATION CONFIGURATION
  WORKSTATION_CONFIGURATIONS_CREATE_NEW,
  WORKSTATION_CONFIGURATIONS_GET_ONE,
  WORKSTATION_CONFIGURATIONS_GET_ALL,

  // SUPPORT_PROJECTS
  SUPPORT_PROJECTS_GET_ALL,
  SUPPORT_PROJECTS_CREATE_NEW,
  SUPPORT_PROJECTS_GET_ONE,
  SUPPORT_PROJECTS_UPDATE_ONE,
  SUPPORT_PROJECTS_DELETE_ONE,
  SUPPORT_PROJECTS_RESTORE_ONE,
  SUPPORT_PROJECTS_SEND_CCM,
  SUPPORT_PROJECTS_ASSIGN_CONTACT_PERSONS_CCM,

  // SUPPORT TICKETS
  SUPPORT_TICKETS_GET_ALL,
  SUPPORT_TICKETS_UPDATE_ONE,
  SUPPORT_TICKETS_INTERNAL,
  SUPPORT_TICKETS_CUSTOMER_CREATION_CCM,
  SUPPORT_TICKETS_CUSTOMER_RESPONSE_CCM,
  SUPPORT_TICKETS_INTERNAL_CREATION_CCM,
  SUPPORT_TICKETS_INTERNAL_RESPONSE_CCM,

  // SUPPORT RELEASES
  SUPPORT_RELEASES_GET_ALL,
  SUPPORT_RELEASES_CREATE_NEW,
  SUPPORT_RELEASES_DELETE_ONE,
  SUPPORT_RELEASES_UPDATE_ONE,
  SUPPORT_RELEASES_GET_ONE,
  SUPPORT_RELEASES_SEND_CCM,
  EMPLOYEES_GET_ALL,

  // ATTENDANCE
  ATTENDANCE_CREATE_NEW,
  ATTENDANCE_UPDATE,
  ATTENDANCE_GET_ALL,
  ATTENDANCE_FIND_ACTIVE_CLOCKINS,
  ATTENDANCE_CLOCKIN_COUNT,

  // ATTENDANCE CONFIGURATION
  ATTENDANCE_CONFIGURATIONS_CREATE_NEW,
  ATTENDANCE_CONFIGURATIONS_GET_ONE,
  ATTENDANCE_CONFIGURATIONS_GET_ALL,

  // ATTENDANCE BULK UPLOAD
  ATTENDANCE_BULK_UPLOAD_CREATE_NEW,
  ATTENDANCE_BULK_UPLOAD_GET_ALL_DUPLICATES,
  ATTENDANCE_BULK_UPLOAD_GET_ALL_RECORDS,
  ATTENDANCE_BULK_UPLOAD_UPDATE_SELECTION,
  ATTENDANCE_BULK_UPLOAD_ADD_AUTHORIZERS,
  ATTENDANCE_UPDATE_SELECTION,

  // ATTENDANCE FILES
  ATTENDANCE_GET_ALL_FILES,
  ATTENDANCE_GET_FILE_DETAILS,
  ATTENDANCE_GET_DUPLICATE_FOR_APPROVAL,
  ATTENDANCE_GET_ALL_FOR_APPROVAL,
  ATTENDANCE_ADD_APPROVAL_REQUEST_DECISION,
  ATTENDANCE_APPROVAL_REQUEST_UPDATE_AUTHORIZERS,

  // ------------------------------------------------------ CLIENT ENDPOINTS ------------------------------------------------------ //
  // REFERENCES - REFERENCE_CATEGORIES
  CLIENT_REFERENCE_CATEGORIES_REFERENCES_GET_ALL,
  // REFERENCES - REFERENCES
  CLIENT_REFERENCES_FIELDS_GET_VALUE,
  // ------------------------------------------------------ CLIENT ENDPOINTS ------------------------------------------------------ //

  // ------------------------------------------------------ EXTERNAL ENDPOINTS ------------------------------------------------------ //
  // REFERENCES - REFERENCE_CATEGORIES
  EXTERNAL_REFERENCE_CATEGORIES_REFERENCES_GET_ALL,
  // REFERENCES - REFERENCES
  EXTERNAL_REFERENCES_FIELDS_GET_VALUE,
  // ------------------------------------------------------ EXTERNAL ENDPOINTS ------------------------------------------------------ //

  // ------------------------------------------------------ IAM ENDPOINTS ------------------------------------------------------ //
  // REFERENCES - REFERENCE_CATEGORIES
  IAM_REFERENCE_CATEGORIES_REFERENCES_GET_ALL,
  // REFERENCES - REFERENCES
  IAM_REFERENCES_FIELDS_GET_VALUE,
  // ------------------------------------------------------ IAM ENDPOINTS ------------------------------------------------------ //
}
